import { render, staticRenderFns } from "./kuaishouPeople.vue?vue&type=template&id=00a6af7e"
import script from "./kuaishouPeople.vue?vue&type=script&lang=js"
export * from "./kuaishouPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports